import React from "react";
import { useTranslation } from "react-i18next";
import { sparkle } from "../../common/imagePath";

const HelpfulTipsCard = ({
  tips,
  bulletIcon,
  BulletComponent,
  cardClass = "",
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`mx-4 mb-4 rounded-2xl overflow-hidden border border-[#DEDEDE] dark:bg-[#121212] dark:border-[#1B1C1E] ${cardClass}`}
    >
      <div className="px-4 py-4">
        <div className="flex items-center gap-2 mb-3">
          <img src={sparkle} alt="" className="w-5 h-5 object-contain" />
          <h3 className="text-base font-bold text-[#1C1C1E] dark:text-white">
            {t("common.helpfulTips")}
          </h3>
        </div>
        <div className="flex flex-col gap-2">
          {tips.map((tip, i) => (
            <div key={i} className="flex items-start gap-2">
              <div className="flex-shrink-0">
                {BulletComponent ? (
                  <BulletComponent />
                ) : (
                  <img src={bulletIcon} alt="" />
                )}
              </div>
              <p className="text-xs lg:text-sm text-[#636363] dark:text-[#A1A1A1] dark:opacity-60 leading-snug font-inter font-normal">
                {tip}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HelpfulTipsCard;
